import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { WalletService } from '../../../../../services/wallet';
import { DeviceDetectorService } from '../../../../../services/device-detector.service';
import { UserService } from '../../../../../services/user';
import { Router } from '@angular/router';
import { isPlatformBrowser, Location } from '@angular/common';
@Component({
  selector: 'app-userwallet',
  templateUrl: './userwallet.component.html',
  styleUrl: './userwallet.component.scss'
})
export class UserwalletComponent implements OnInit {

  isAr = false;
  contentReady = true;
  isMobile = false;

  balance: any = 0;
  id: any;
  transactions: any[] = [];

  private isBrowser: boolean;

  constructor(
    private walletService: WalletService,
    private deviceService: DeviceDetectorService,
    private _userService: UserService,
    private location: Location,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ================= INIT =================
  ngOnInit(): void {

    // Browser-only logic
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
      this.isMobile = this.deviceService.isMobileDevice();
    }

    this.userId();
  }
  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/home']);
    }
  }
  // ================= USER =================
  userId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data.user_id;
        this.loadUserBalance(this.id);
      },
      error: () => {
        this.contentReady = false;
      },
    });
  }

  // ================= WALLET =================
  loadUserBalance(id: any): void {
    this.contentReady = true;

    this.walletService.getUserWallet(id).subscribe({
      next: (res) => {
        this.balance = res.balance || 0;
        this.transactions = res.transactions || [];

        this.getTransactions(id);
      },
      error: (err) => {
        this.balance = 0;
        this.transactions = [];


        this.contentReady = false;
      }
    });
  }

  getTransactions(id: any): void {
    this.walletService.getUserTransactions(id).subscribe({
      next: (res) => {
        this.transactions = res.transactions || [];
        this.contentReady = false;
      },
      error: () => {
        this.contentReady = false;
      }
    });
  }

  // ================= HELPERS =================
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}-${month}-${year}`;
  }
}
